import React from "react";
import { MdOutlineLogout } from "react-icons/md";
import Login from "./components/login";
import Projetos from "./components/projetos";
import { Container, Card } from "./styles";
import logo from "@imgs/logo.svg";
import { useAuth } from "@hooks/auth";

export default function Auth() {
  const { status, user, logout } = useAuth();

  const stages = [
    {
      status: "login",
      comp: <Login />,
    },
    {
      status: "projetos",
      comp: <Projetos />,
    },
    // Você pode adicionar outros estágios, se necessário.
  ];

  const Stages = () => {
    const stage = stages.find((obj) => obj.status === status);
    return stage ? stage.comp : <></>;
  };

  // Mostrar botão de logout apenas se o usuário estiver logado
  const showLogoutButton = status !== "login" && user;

  return (
    <Container>
      <Card>
        <div className="header">
          <img src={logo} alt="Logo" />
          {showLogoutButton && (
            <div className="btn" onClick={logout} title="Sair do sistema">
              <MdOutlineLogout />
            </div>
          )}
        </div>
        <Stages />
      </Card>
    </Container>
  );
}
